// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[role=list][data-v-643ba093]{font-family:var(--font-family)}[role=listitem][data-v-643ba093]{&[data-v-643ba093]:first-child{border-top-left-radius:.4375rem}&[data-v-643ba093]:last-child{border-top-right-radius:.4375rem}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
